import { Component } from 'react';
import PropTypes from 'prop-types';
import EditSvg from 'images/shared/edit.svg';

class CalculationValue extends Component {
  render() {
    const {
      label,
      value,
      editable,
      svgClickHandler,
    } = this.props;

    return (
      <div className="calculation-value">
        <span className="label">{label}</span>
        <span className="value">{value}</span>
        {
          editable ? (
            <button type="button" className="action" onClick={svgClickHandler}>
              <EditSvg />
            </button>
          ) : null
        }
      </div>
    );
  }
}

CalculationValue.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  editable: PropTypes.bool,
  svgClickHandler: PropTypes.func,
};

CalculationValue.defaultProps = {
  editable: false,
  svgClickHandler: () => {},
};

export default CalculationValue;
